window.excludedFromSiteWideSale = new Set([
  // "42218358636724", // floral toile top
  // "42218358669492",
  // "42218358702260",
  // "42218359161012",
  // "42218359193780",
  // "42218359226548",
  // "42218359259316",
  // "42218373349556", // Floral Toile pant
  // "42218373513396",
  // "42218373546164",
  // "42218373578932",
  // "42218373611700",
  // "42218374955188",
  // "42218375282868",
  // "42218402054324", // Floral Toile - Long sleeve set
  // "42218402087092",
  // "42218402119860",
  // "42218402152628",
  // "42218402185396",
  // "42218402218164",
  // "42218402250932",
  // "42218402676916", // Floral Toile - Short sleeve set
  // "42218402709684",
  // "42218402742452",
  // "42218402840756",
  // "42218402906292",
  // "42218402939060",
  // "42218402971828",
  // "42218362273972", // Floral Toile - Short
  // "42218362306740",
  // "42218362339508",
  // "42218362372276",
  // "42218362405044",
  // "42218362470580",
  // "42218362503348",
  // "42218357948596", // Floral Toile - Top short sleeve
  // "42218357981364",
  // "42218358014132",
  // "42218358046900",
  // "42218358079668",
  // "42218358112436",
  // "42218358145204",
  // // "41910392258740", // Navy Bamboo Sheet Set
  // // "41910392291508",
  // // "41910392324276",
  // // "41910392357044",
  // // "41910392389812",
  // // "41910392422580",
  // // "41910392455348", // Olive Bamboo Sheet Set
  // // "41910392488116",
  // // "41910392520884",
  // // "41910392553652",
  // // "41910392586420",
  // // "41910392619188",
  // // "41910296871092", // Navy Bamboo Pillowcases
  // // "41910296903860",
  // // "41910296969396", // Olive Bamboo Pillowcases
  // // "41910296936628",
  // // "41910322659508", // Navy Bamboo Duvet Cover
  // // "41910322692276",
  // // "41910322725044",
  // // "41910322757812", // Olive Bamboo Duvet Cover
  // // "41910322790580",
  // // "41910322823348",
  // // "41910331343028", // Navy Bamboo Fitted Sheet
  // // "41910331408564",
  // // "41910331474100",
  // // "41910331539636",
  // // "41910331605172",
  // // "41910331375796", // Olive Bamboo Fitted Sheet
  // // "41910331441332",
  // // "41910331506868",
  // // "41910331572404",
  // // "41910331637940",
  // // "41910340911284", // Navy Bamboo Flat Sheet
  // // "41910340976820",
  // // "41910341042356",
  // // "41910341107892",
  // // "41910340944052", // Olive Bamboo Flat Sheet
  // // "41910341009588",
  // // "41910341075124",
  // // "41910341140660",
  // "42343809286324", // Women's Stretch-Knit Long Sleeve Bamboo Pajama Set
  // "42343809319092",
  // "42343809351860",
  // "42343809384628",
  // "42343809417396",
  // "42343809450164",
  // "42343809482932",
  // "42343809515700",
  // "42343809548468",
  // "42343809581236",
  // "42343809614004",
  // "42343809646772",
  // "42343809679540",
  // "42343809712308",
  // "42343809745076",
  // "42343809777844",
  // "42343809810612",
  // "42343809843380",
  // "42343809876148",
  // "42343809908916",
  // "42343809941684",
  // "42343748993204", // Women's Stretch-Knit Bamboo Pajama Pant - 30” Inseam
  // "42343749025972",
  // "42343749058740",
  // "42343749091508",
  // "42343749124276",
  // "42343749157044",
  // "42343749189812",
  // "42343749222580",
  // "42343749255348",
  // "42343749288116",
  // "42343749320884",
  // "42343749353652",
  // "42343749386420",
  // "42343749419188",
  // "42343749451956",
  // "42343749484724",
  // "42343749517492",
  // "42343749550260",
  // "42343749583028",
  // "42343749615796",
  // "42343749648564",
  // "42343746044084", // Women's Long Sleeve Bamboo Pajama Top in Stretch-Knit
  // "42343746076852",
  // "42343746109620",
  // "42343746142388",
  // "42343746175156",
  // "42343746207924",
  // "42343746240692",
  // "42343746273460",
  // "42343746306228",
  // "42343746338996",
  // "42343746371764",
  // "42343746404532",
  // "42343746437300",
  // "42343746470068",
  // "42343746502836",
  // "42343746535604",
  // "42343746568372",
  // "42343746601140",
  // "42343746633908",
  // "42343746666676",
  // "42343746699444",
  // "42343803289780", // Women's Stretch-Knit Short Sleeve Bamboo Pajama Set
  // "42343803322548",
  // "42343803355316",
  // "42343803388084",
  // "42343803420852",
  // "42343803453620",
  // "42343803486388",
  // "42343803519156",
  // "42343803551924",
  // "42343803584692",
  // "42343803617460",
  // "42343803650228",
  // "42343803682996",
  // "42343803715764",
  // "42343803748532",
  // "42343803781300",
  // "42343803814068",
  // "42343803846836",
  // "42343803879604",
  // "42343803912372",
  // "42343803945140",
  // "42343736311988", // Women's Bamboo Pajama Short in Stretch-Knit
  // "42343736344756",
  // "42343736377524",
  // "42343736410292",
  // "42343736443060",
  // "42343736475828",
  // "42343736508596",
  // "42343736541364",
  // "42343736574132",
  // "42343736606900",
  // "42343736639668",
  // "42343736672436",
  // "42343736705204",
  // "42343736737972",
  // "42343736770740",
  // "42343736803508",
  // "42343736836276",
  // "42343736869044",
  // "42343736901812",
  // "42343736934580",
  // "42343736967348",
  // "42343725826228", // Women's Short Sleeve Bamboo Pajama Top in Stretch-Knit
  // "42343725858996",
  // "42343725891764",
  // "42343725924532",
  // "42343725957300",
  // "42343725990068",
  // "42343726022836",
  // "42343726055604",
  // "42343726088372",
  // "42343726121140",
  // "42343726153908",
  // "42343726186676",
  // "42343726219444",
  // "42343726252212",
  // "42343726284980",
  // "42343726317748",
  // "42343726350516",
  // "42343726383284",
  // "42343726416052",
  // "42343726448820",
  // "42343726481588",
  // "42076194013364", // Just a bunch of codes for PJs, sorry future whoever reads this
  // "42076194046132",
  // "42076194078900",
  // "42076194111668",
  // "42076194144436",
  // "42076194177204",
  // "42076194209972",
  // "42343690371252",
  // "42343690404020",
  // "42343690436788",
  // "42343690469556",
  // "42343690502324",
  // "42343690535092",
  // "42343690567860",
  // "42076208922804",
  // "42076208955572",
  // "42076208988340",
  // "42076209021108",
  // "42076209053876",
  // "42076209086644",
  // "42076209119412",
  // "42259553681588",
  // "42259553714356",
  // "42259553747124",
  // "42259553779892",
  // "42259553812660",
  // "42259553845428",
  // "42259553878196",
  // "42408778170548",
  // "42408778203316",
  // "42408778236084",
  // "42408778268852",
  // "42408778301620",
  // "42408778334388",
  // "42408778367156",
  // "42408772239540",
  // "42408772272308",
  // "42408772305076",
  // "42408772337844",
  // "42408772370612",
  // "42408772403380",
  // "42408772436148",
  // "42408642838708",
  // "42408642871476",
  // "42408642904244",
  // "42408642937012",
  // "42408642969780",
  // "42408643002548",
  // "42408643035316",
  // "42408614920372",
  // "42408614953140",
  // "42408614985908",
  // "42408615018676",
  // "42408615051444",
  // "42408615084212",
  // "42408615116980",
  // "42340020158644",
  // "42340020191412",
  // "42340020224180",
  // "42340020256948",
  // "42340020289716",
  // "42340020322484",
  // "42340020355252",
  // "42259560759476",
  // "42259560792244",
  // "42259560825012",
  // "42259560857780",
  // "42259560890548",
  // "42259560923316",
  // "42259560956084",
  // "42408575074484",
  // "42408575107252",
  // "42408575140020",
  // "42408575172788",
  // "42408575205556",
  // "42408575238324",
  // "42408575271092",
  // "42408579760308",
  // "42408579793076",
  // "42408579825844",
  // "42408579858612",
  // "42408579891380",
  // "42408579924148",
  // "42259553681588"
]);
